// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"81":"11fd2f8f3c95f1ec","926":"ed9d8799664f93fb"}[chunkId] + ".js";
};